import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Input,
  Modal,
  Typography,
  Divider,
  Form,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BarcodeScanner from "../Scanner/BarCodeScanner";
import "../../../styles/global-ui.css";

const { Title, Text } = Typography;

const BinBulkScanOutward = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const binId = values.binId;

    if (!binId) return;

    setSubmitLoading(true);

    try {
      navigate(`/wc-bin-bulk-outward?binId=${encodeURIComponent(binId)}`);
    } catch (error) {
      console.error("Navigation error:", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleScan = (result) => {
    setIsModalOpen(false);
    setSubmitLoading(true);

    try {
      handleSubmit({ binId: result });
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleScanError = (error) => {
    console.error("Scanner error:", error);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              style={{ marginRight: 10, cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
            Scan Bulk Outward
          </Title>
          <Text className="page-subtitle">
            Scan bins to add into bulk outward list
          </Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card" style={{ maxWidth: 420, margin: "0 auto" }}>
        <div style={{ textAlign: "center" }}>
          <div
            className="dashboard-stat-card bg-card-blue"
            style={{ minHeight: 90, opacity: submitLoading ? 0.7 : 1 }}
            onClick={() => !submitLoading && setIsModalOpen(true)}
          >
            <div
              className="dashboard-stat-card-inner"
              style={{
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div className="dashboard-stat-title">SCAN BIN</div>
              <Text style={{ color: "#475569", fontSize: 13 }}>
                Tap to open scanner
              </Text>
            </div>
          </div>

          <Divider>OR</Divider>

          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              name="binId"
              label="Enter Bin ID"
              rules={[
                {
                  required: true,
                  message: "Bin ID is required",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter Bin ID"
                style={{ textAlign: "center" }}
                disabled={submitLoading}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                className="primary-btn"
                loading={submitLoading}
                disabled={submitLoading}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Card>

      <Modal
        title="Scan QR Code"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </div>
  );
};

export default BinBulkScanOutward;